import locale from '../locale/zh_CN'; // 默认使用中文
export default locale;
